module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BU5kyN/tc-custom/9781625855558.jpg?1737918818342",
      "alt": "This image is the cover for the book Buried Beneath Cleveland"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Buried Beneath Cleveland\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“His book tells about many of the graves of Revolutionary War and Civil War soldiers, as well as the early pioneers and those who settled the county.” —"), _c('i', [_vm._v("Cleveland.com")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The dead do not always rest in peace. Occasionally, they wind up in the backyard. As towns grew in Cuyahoga County during the late 1800s, many of its cemeteries were relocated to make room for urban sprawl."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But not all of these graves made the journey. Author William G. Krejci tracks down more than fifty displaced cemeteries throughout the Greater Cleveland area. Discover the Revolutionary War veterans, famous scientists and illustrious dignitaries found beneath gas stations and grocery stores in this eerie history of Cuyahoga County’s forgotten dead.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William G. Krejci\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("William G. Krejci is a seasonal park ranger at Perry's Victory and International Peace Memorial in Put-in-Bay. Raised in the greater Cleveland area, William is also a former volunteer docent at Cleveland's Gesangeverein Hall and at Prospect Place in Trinway, Ohio. William is the author of three mystery detective novels and has been discovering and documenting historical sites in northeast Ohio for years. He studied video production, film and screenplay writing at the Art Institute of Pittsburgh.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0